module.exports = __webpack_public_path__ + "static/media/智能机械臂.b02c0479.png";